var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Date",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-date-1360178",
    transform: "translate(-20.276 25.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M21.434,6.04h-.577V5.077A.577.577,0,0,0,20.28,4.5h-2.5a.577.577,0,0,0-.577.577V6.04H13.544V5.077a.577.577,0,0,0-.577-.577h-2.5a.577.577,0,0,0-.577.577V6.04H9.12A2.117,2.117,0,0,0,7,8.157V19.9a2.117,2.117,0,0,0,2.117,2.117H21.434A2.117,2.117,0,0,0,23.551,19.9V8.157A2.117,2.117,0,0,0,21.434,6.04Zm-3.079-.385H19.7V7.579H18.355Zm-7.313,0h1.347V7.579H11.042ZM9.117,7.194h.77v.962a.577.577,0,0,0,.577.577h2.5a.577.577,0,0,0,.577-.577V7.194H17.2v.962a.577.577,0,0,0,.577.577h2.5a.577.577,0,0,0,.577-.577V7.194h.577a.962.962,0,0,1,.962.962v2.309H8.155V8.157a.962.962,0,0,1,.962-.962ZM21.434,20.859H9.117a.962.962,0,0,1-.962-.962V11.621H22.4V19.9a.962.962,0,0,1-.966.959Z",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 3.079,
    height: 3.079,
    transform: "translate(9.727 12.679)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 3.079,
    height: 3.079,
    transform: "translate(13.769 12.679)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 3.079,
    height: 3.079,
    transform: "translate(17.745 12.679)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 3.079,
    height: 3.079,
    transform: "translate(9.727 16.529)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 3.079,
    height: 3.079,
    transform: "translate(13.769 16.529)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 3.079,
    height: 3.079,
    transform: "translate(17.745 16.529)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCard);
export default __webpack_public_path__ + "static/media/DateCard.da1f49af06eb7e1258d47437ec30b518.svg";
export { ForwardRef as ReactComponent };